import './SplashScreen.css'
import fourteenPoints from "../images/fourteenPoints.png"
import React from "react"

function SplashScreen(props) {

    return (
        <div className="loadingBlock">
            <div className="fadeImageIn"> 
                <img className="loadingCircleImage" src={fourteenPoints} alt="circle outline with two interupting rectangles" />
            </div>
        </div>
    )
}

export default SplashScreen;